'use strict';


var Footer = require('mag-component-footer');


module.exports = {
    prepare: function ( page ) {
        this.instance = new Footer({
            visible: false,
            parent:  page
        });
    },
    instance: null
};
